import React, { useState, useEffect, Ref } from 'react';
import { TextField } from '@gerdau/hefesto';
import useDebounce from '../../../../../../../hooks/useDebounce';
import { TextFieldProps } from '@gerdau/hefesto/TextField/TextField.types';

const FabricationDebouncedTextField = (props: TextFieldProps) => {
  const [debounceValue, setDebounceValue] = useState(props.value);

  const debounceChange = props.onChange
    ? useDebounce(props.onChange, 500)
    : () => undefined;

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDebounceValue(e.target.value);
    debounceChange(e);
  };

  useEffect(() => {
    setDebounceValue(props.value);
  }, [props.value]);

  return (
    <TextField
      {...props}
      value={debounceValue}
      onChange={onChange}
      ref={props.ref as Ref<HTMLInputElement> | undefined}
    />
  );
};

export default FabricationDebouncedTextField;
